module.exports = __webpack_public_path__ + "static/homepage_desktop_vertical_flow-7948f7335a233d121aaa40b4e4ee7121.png";